// extracted by mini-css-extract-plugin
export default {"header":"blocks_headerv2_header","title":"blocks_headerv2_title","right":"blocks_headerv2_right"};